import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  CommercialListBaseComponent,
  CommercialListStore,
} from '@epicuro-next/features/engagement/commercial-list-store';
import { List } from '@epicuro-next/models/engagement';

@Component({
  selector: 'epc-shop-the-commercial-list',
  templateUrl: './shop-the-commercial-list.component.html',
  styleUrls: ['./shop-the-commercial-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CommercialListStore],
  standalone: false,
})
export class ShopTheCommercialListComponent extends CommercialListBaseComponent {
  public multiplierOptions = Array.from(Array(10).keys()).map((v) => v + 1);

  @Input()
  public set list(list: List) {
    this.componentStore.setList(list);
  }

  constructor(public componentStore: CommercialListStore) {
    super(componentStore);
  }
}
